import axios from 'axios'
import { baseAPICall } from 'services/baseAPICall'
import { clientInstance } from 'utils/http-client'

/** Result returned by the undo-import endpoint. */
export interface UndoImportResult {
  contacts_deleted: number
  companies_deleted: number
}

/**
 * HTTP status returned by the backend when the undo window has elapsed.
 *
 * Cross-reference: the backend window guard lives in
 * `server/importengine/service/v2/undo_import.py` (UNDO_WINDOW), surfaced via
 * `ImportPreviewUndoView` as a 409.
 */
export const UNDO_WINDOW_EXPIRED_STATUS = 409

/**
 * Undo a contacts-only import: delete the contacts and custom-Other companies
 * that this import newly created.
 *
 * 409 (window expired) is thrown silently — the caller handles it inline rather
 * than via a global error toast.
 */
export async function performUndoImport(
  importNumber: number
): Promise<UndoImportResult> {
  return baseAPICall<UndoImportResult>(
    () => clientInstance.post(`importengine/previews/v2/${importNumber}/undo/`),
    { silentStatuses: [UNDO_WINDOW_EXPIRED_STATUS] }
  )
}

/** True when the given error is the backend's "undo window expired" 409. */
export function isUndoWindowExpiredError(err: unknown): boolean {
  return (
    axios.isAxiosError(err) &&
    err.response?.status === UNDO_WINDOW_EXPIRED_STATUS
  )
}
